import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import axios from "axios";

function Category07() {
  const [data, setData] = useState([]);

  useEffect(() => {
    axios
      .get("https://adhigyanam-e92bf1bbbdb1.herokuapp.com/astrocategoriessort") // Update with actual backend URL
      .then((response) => {
        setData(response.data); // Store response in state
      })
      .catch((error) => console.error("Error fetching data:", error));
  }, []);

  return (
    <section className="testimonials-category-section" style={{ paddingTop: "20px", paddingBottom:"20px" }}>
      <div className="tf-container">

     

        <div className="row">
          <div className="col-md-12">
            <div className="tf-title style-2" style={{marginBottom:"20px"}}>
              <div className="group-title">
                <h1  style={{ marginBottom: "0px", fontSize:"30px" }}>eConsultation Services</h1>
                <p>
                  Thoughtfully crafted sessions to help you discover your spiritual connection.
                </p>
              </div>
            </div>
          </div>

          <div className="col-md-10" style={{margin:"auto"}}>
            <div className="row">
              {data.map((item, index) => (
                <div key={index} className="col-lg-3 col-md-4 col-6">
                  <div className="group-category-job padding wow fadeInUp" style={{paddingBottom:"10px"}}>
                  <Link to={`/category-details/${item.Id}`}>
                    <div className="job-category-box" style={{width:"unset", padding:"18px"}}>
                      <div className="job-category-header" style={{marginBottom:"0px"}}>
                        <img
                          src={item.Path1 || "default-image.jpg"} // Use Path1 for image
                          alt={item.Named}
                          style={{ width: "100%", height: "auto", borderRadius: "10px" }}
                        />
                        <h1 style={{marginTop:"15px", fontWeight: "600", 
    fontSize:"16px"}}>
                          <Link to={`/category-details/${item.Id}`}>{item.Named}</Link>
                        </h1>
                        <p style={{marginBottom:"5px"}}>{item.Qdesc}</p>
                         <Link to={`/category-details/${item.Id}`} className="btn-category-job">
                            View Details
                            <span className="icon-keyboard_arrow_right"></span>
                          </Link>
                      </div>
                    
                     
                    </div>
                    </Link>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default Category07;